import type { RouteLocationRaw, RouteLocationNormalized } from 'vue-router';
import { getPermittedHomeRoute } from '../../functions/permissions/getPermittedHomeRoute';
import ROUTE_NAMES from '../../../../vue/routes/routeNames';
import type { RouterListener } from './RouterListener';
import appApi from '../../../api/app/AppApi';
import { useUserStore } from '@/vue/stores/user';
import { usePermissionsStore } from '../../../../vue/stores/permissions';
import { useIsAnonymousStore } from '@/vue/stores/isAnonymous';

const loadPermissions = async () => {
    const { all, user } = await appApi.getPermissions();

    usePermissionsStore().setAllPermissions(all);
    useUserStore().setPermissions(user);
};

export default class HomeRouteListener implements RouterListener {
    public async onBeforeEach(to: RouteLocationNormalized): Promise<boolean | RouteLocationRaw> {
        const isAnonymousStore = useIsAnonymousStore();
        const userStore = useUserStore();
        const permissionsStore = usePermissionsStore();

        const permissionsLoaded = userStore.arePermissionsSet
            && permissionsStore.areAllPermissionsSet;

        if (!isAnonymousStore.isAnonymous && !permissionsLoaded) {
            await loadPermissions();
        }

        const isHomeRoute = to.name === ROUTE_NAMES.HOME;

        const hasHomePagePermission = userStore.hasPermission(
            permissionsStore.allPermissions.generalHome,
        );

        if (!isHomeRoute || hasHomePagePermission) {
            return true;
        }

        const nextRoute = getPermittedHomeRoute();
        if (nextRoute === null) {
            return { name: ROUTE_NAMES.NO_ACCESS };
        }

        return ({ name: nextRoute });
    }
}
